import * as moment from 'moment';
import { User } from './user';

export class IdToken {
  private readonly encodedToken: string;
  private readonly decodedTokenBody: any;

  constructor(tokenEncodedBase64: string) {
    this.encodedToken = tokenEncodedBase64;
    if (tokenEncodedBase64) {
      this.decodedTokenBody = JSON.parse(
        atob(tokenEncodedBase64.split('.')[1])
      );
    }
  }

  getEncodedToken() {
    return this.encodedToken;
  }

  getDecodedTokenBody() {
    return this.decodedTokenBody;
  }

  getExpiration() {
    return moment(this.decodedTokenBody.exp * 1000);
  }

  isExpired(): boolean {
    return this.getExpiration().isBefore(moment());
  }

  getMillisTillExpiration() {
    return this.getExpiration().diff(moment());
  }

  isValid(): boolean {
    return this.decodedTokenBody != null && !this.isExpired();
  }

  getUser(): User {
    const user = new User();
    if (this.decodedTokenBody) {
      user.username = this.decodedTokenBody['cognito:username'];
      user.familyName = this.decodedTokenBody['family_name'];
      user.givenName = this.decodedTokenBody['given_name'];
      user.fullName = [user.givenName, user.familyName].join(' ');
      user.email = this.decodedTokenBody['email'];
      user.phone = this.decodedTokenBody['phone_number'];
      user.securityGroups = this.decodedTokenBody['cognito:groups'];
    }
    return user;
  }
}
